import moment from 'moment';
import { WorkingDaysConfiguration } from 'components/organisms/user-capacity';
import {
  isDateBetweenRange,
  shiftDateIfOnNonWorkingDay,
} from '../../utils/dates';
import { ViewPresetId } from './constants';
import { ViewPreset } from './view-presets';

const MonthViewPreset = () => ({
  base: 'monthAndYear',
  incrementBy: 'week',
  timeResolution: {
    unit: 'day',
    increment: 1,
  },
  tickWidth: 6,
  columnLinesFor: 2,
  shiftUnit: 'month',
  shiftIncrement: 1,
  headers: [
    {
      unit: 'year',
      increment: 1,
      align: 'start',
      renderer: (startDate: Date) => {
        return `<strong>${moment(startDate).format('YYYY')}</strong>`;
      },
    },
    {
      unit: 'month',
      increment: 1,
      align: 'start',
      renderer: (startDate: Date, endDate: Date, config) => {
        if (
          isDateBetweenRange(moment(), {
            startDate: moment(startDate),
            endDate: moment(endDate).subtract(1, 'minute'),
          })
        ) {
          // eslint-disable-next-line no-param-reassign
          config.headerCellCls = 'current-day';
        }

        return moment(startDate).format('MMM');
      },
    },
    {
      unit: 'week',
      increment: 1,
    },
    {
      unit: 'day',
      increment: 1,
    },
  ],
});
const WeekViewPreset = (workingDaysConfig: WorkingDaysConfiguration) => ({
  base: 'monthAndYear',
  incrementBy: 'day',
  timeResolution: {
    unit: 'day',
    increment: 1,
  },
  tickWidth: 24,
  shiftUnit: 'week',
  shiftIncrement: 1,
  headers: [
    {
      unit: 'year',
      increment: 1,
    },
    {
      unit: 'month',
      increment: 1,
      align: 'start',
      renderer: (startDate: Date) => {
        return `<strong>${moment(startDate).format("MMM 'YY")}</strong>`;
      },
    },
    {
      unit: 'week',
      increment: 1,
      align: 'start',
      renderer: (startDate: Date, endDate: Date, config) => {
        if (
          isDateBetweenRange(moment(), {
            startDate: moment(startDate),
            endDate: moment(endDate).subtract(1, 'minute'),
          })
        ) {
          // eslint-disable-next-line no-param-reassign
          config.headerCellCls = 'current-day';
        }

        return `${shiftDateIfOnNonWorkingDay(
          moment(startDate),
          workingDaysConfig,
        ).format('DD')}-${shiftDateIfOnNonWorkingDay(
          moment(endDate),
          workingDaysConfig,
          false,
        ).format('DD')}`;
      },
    },
    {
      unit: 'day',
      increment: 1,
    },
  ],
});

export const getDemandViewZoomPresets = (
  workingDaysConfig: WorkingDaysConfiguration,
): ViewPreset[] => [
  {
    id: ViewPresetId.Month,
    ...MonthViewPreset(),
  },
  {
    id: ViewPresetId.Week,
    ...WeekViewPreset(workingDaysConfig),
  },
];

export const UserSelectablePresetIdForDemand = [
  ViewPresetId.Month,
  ViewPresetId.Week,
];

export const ValidViewPresetsForDemand = [
  ViewPresetId.Week,
  ViewPresetId.Month,
];
